import { Route } from "react-router-dom";

import ElectionCommittee from "pages/dataCollection/Budget";
import StudentCouncil from "pages/dataCollection/Bylaws";
import DataEdit from "pages/dataCollection/DataEdit";
import DataRegister from "pages/dataCollection/DataRegister";
import BudgetCommittee from "pages/dataCollection/Other";
import ClubUnion from "pages/dataCollection/VotingBody";

export function getDataCollectionRoutes() {
  return (
    <Route path="/dataCollection">
      <Route path="register/:category" element={<DataRegister />} />
      <Route path="votingBody" element={<ClubUnion />} />
      <Route path="votingBody/:dataNoticeId" element={<DataEdit />} />
      <Route path="budget" element={<ElectionCommittee />} />
      <Route path="budget/:dataNoticeId" element={<DataEdit />} />
      <Route path="bylaws" element={<StudentCouncil />} />
      <Route path="bylaws/:dataNoticeId" element={<DataEdit />} />
      <Route path="other" element={<BudgetCommittee />} />
      <Route path="other/:dataNoticeId" element={<DataEdit />} />
    </Route>
  );
}
